import Header from './components/Header';
import Hero from './components/Hero';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import FAQSection from './components/FAQSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FeaturesSection />
        <CardsSection />
        <IndexSection />
        <MediaSection />
        <AppSection />
        <FAQSection />
        <AboutSection />
        <ContactSection />
        <TopicsSection />
        <UpdatesSection />
        <RankingSection />
        <CarouselSection />
        <CommentsSection />
      </main>
      <Footer />
    </>
  );
}